import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="footer-gradient text-primary-foreground">
            <div className="section-container py-16">
                <div className="grid md:grid-cols-4 gap-12 lg:gap-16">
                    {/* Shop Address */}
                    <div className="text-center md:text-left">
                        <h3 className="text-xl font-semibold mb-6">Shop Address</h3>
                        <div className="flex flex-col items-center md:items-start gap-2">
                            <MapPin className="w-6 h-6 opacity-80" />
                            <p className="text-primary-foreground/90 leading-relaxed">
                                Devalkhedi Jhod Jadgdishpur Islam Nagar Road Bhopal,<br />
                                Bhopal, Madhya Pradesh 462038
                            </p>
                        </div>
                    </div>

                    {/* Contact With Us */}
                    <div className="text-center md:text-left">
                        <h3 className="text-xl font-semibold mb-6">Contact With Us</h3>
                        <div className="space-y-4">
                            <a 
                                href="mailto:prashantdhakad12345@gmail.com"
                                className="flex items-center justify-center md:justify-start gap-2 text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                <Mail className="w-5 h-5" />
                                prashantdhakad12345@gmail.com
                            </a>
                            <a 
                                href="tel:+917999436770"
                                className="flex items-center justify-center md:justify-start gap-2 text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                <Phone className="w-5 h-5" />
                                +917999436770
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="text-center md:text-left">
                        <h3 className="text-xl font-semibold mb-6">Quick Links</h3>
                        <div className="space-y-3">
                            <Link 
                                to="/privacy-policy"
                                className="block text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                Privacy Policy
                            </Link>
                            <Link 
                                to="/disclaimer"
                                className="block text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                Disclaimer
                            </Link>
                            <Link 
                                to="/terms-and-conditions"
                                className="block text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                Terms & Conditions
                            </Link>
                        </div>
                    </div>

                    {/* Social Links */}
                    <div className="text-center md:text-left">
                        <h3 className="text-xl font-semibold mb-6">Social Links</h3>
                        <div className="space-y-4">
                            <a 
                                href="https://facebook.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center md:justify-start gap-2 text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                </svg>
                                Facebook
                            </a>
                            <a 
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center md:justify-start gap-2 text-primary-foreground/90 hover:text-primary-foreground transition-colors"
                            >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                </svg>
                                Instagram
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="border-t border-primary-foreground/20">
                <div className="section-container py-6">
                    <p className="text-center text-sm text-primary-foreground/80">
                        Dhakad Enterprises – All Right Reserved 2026 – Website Design & Developed By{' '}
                        <a href="https://ashawebtechitsolutions.com/" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-primary-foreground transition-colors">Asha </a>
                        <a href="https://chandrabhansingh.in/" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-primary-foreground transition-colors">WebTech </a>
                        <a href="https://ashawebtechitsolutions.com/" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-primary-foreground transition-colors">IT Solutions </a>
                        <a href="https://marketingtech.in/" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-primary-foreground transition-colors">Pvt Ltd</a>.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
